// extracted by mini-css-extract-plugin
export default {"react-layout":"react-layout___AmiaG","layoutWrap":"layoutWrap___u03a8"};